/* Bandenmeesters 2.1 — actuele-voorraad hero motion only. */
(()=>{
  if(window.__bmStockHeaderRuntime)return;
  window.__bmStockHeaderRuntime=true;

  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHero=(hero)=>{
    if(!hero||hero.dataset.bmStockReady==='true')return;
    hero.dataset.bmStockReady='true';

    const ready=()=>hero.classList.add('is-ready');
    if(reduceMotion||!hero.classList.contains('bm-stock-hero--motion')){ready();return}
    requestAnimationFrame(()=>requestAnimationFrame(ready));

    const visual=hero.querySelector('[data-bm-stock-visual]');
    if(!visual||!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;

    let raf=0;
    const move=(event)=>{
      if(raf)return;
      raf=requestAnimationFrame(()=>{
        raf=0;
        const rect=visual.getBoundingClientRect();
        const x=(event.clientX-rect.left)/Math.max(rect.width,1)-.5;
        const y=(event.clientY-rect.top)/Math.max(rect.height,1)-.5;
        visual.style.setProperty('--bm-stock-x',`${(x*7).toFixed(2)}px`);
        visual.style.setProperty('--bm-stock-y',`${(y*5).toFixed(2)}px`);
      });
    };
    const reset=()=>{
      visual.style.setProperty('--bm-stock-x','0px');
      visual.style.setProperty('--bm-stock-y','0px');
    };
    visual.addEventListener('pointermove',move,{passive:true});
    visual.addEventListener('pointerleave',reset,{passive:true});
  };

  const init=(scope=document)=>scope.querySelectorAll('[data-bm-stock-hero]').forEach(initHero);
  const start=()=>init(document);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
